<template>
  <div class="a-dashboard">
    <v-progress-linear
      :active="loading"
      color="primary"
      indeterminate
    ></v-progress-linear>

    <div class="a-dashboard__map">
      <MapField :display-cluster="clusterLabel" :markers="markers"> </MapField>
    </div>

    <div class="a-dashboard__widgets">
      <v-fade-transition mode="out-in">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </v-fade-transition>
    </div>
  </div>
</template>

<script>
import { provide, watch } from "vue-demi";
import { omitBy } from "lodash";

import { useMap } from "@/composables/api/map";
import { useRoute } from "@/composables/router";

import MapField from "@/components/Field/MapField.vue";

export default {
  components: { MapField },

  setup() {
    const route = useRoute();

    const { markers, measure, execute, loading, clear, clusterLabel } =
      useMap();

    provide("measure", measure);

    provide("clearMap", () => {
      clear();
    });

    provide("showOnMap", params => {
      measure.value = params.measure;

      const qs = omitBy(params, v => !v);
      execute(null, qs);
    });

    watch(route, () => {
      clear();
    });

    return { clusterLabel, loading, markers };
  }
};
</script>

<style lang="scss">
.a-dashboard {
  & > .v-progress-linear {
    position: fixed;
    top: 0;
    z-index: 401;
  }

  &__map {
    position: absolute;
    width: 100vw;
    height: 100vh;
    z-index: 1;

    &:after {
      content: "";

      position: absolute;
      z-index: 401;
      bottom: 0;
      right: 0;
      left: 0;

      background: linear-gradient(to top, white, transparent);
      height: 250px;
    }
  }
}
</style>
